'use client'
import { useHeaderTheme } from '@/providers/HeaderTheme'
import React, { useEffect } from 'react'

// const PageClient: React.FC = () => {
//   /* Force the header to be dark mode while we have an image behind it */
//   const { setHeaderTheme } = useHeaderTheme()

//   useEffect(() => {
//     setHeaderTheme('light')
//   }, [setHeaderTheme])
//   return <React.Fragment />
// }

const PageClient: React.FC = () => {
  const { setHeaderTheme } = useHeaderTheme()

  useEffect(() => {
    // Let the header follow the global theme (no override)
    setHeaderTheme(null)

    // On unmount, also clear any override (safety)
    return () => setHeaderTheme(null)
  }, [setHeaderTheme])

  return null
}

export default PageClient
